import React, { useEffect } from 'react';
import Header from '../Header';
import Footer from '../Footer';

function AboutUs({ view, setView, searchTerm, setSearchTerm, cityFilter, setCityFilter, setActiveTab }) {
  
  // পেজ লোড হলে একেবারে উপরে স্ক্রল করবে
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white flex flex-col font-sans">
      <Header view={view} setView={setView} setSearchTerm={setSearchTerm} setCityFilter={setCityFilter} setActiveTab={setActiveTab} />
      
      <main className="flex-1">
        
        {/* 🚨 HERO SECTION 🚨 */}
        <section className="relative h-[75vh] md:h-[85vh] w-full flex flex-col justify-end pb-16 md:pb-24">
          <img 
            src="https://images.unsplash.com/photo-1494976388531-d1058494cdd8?auto=format&fit=crop&w=2000&q=80" 
            alt="Bah Car Plaza Vision" 
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>
          
          <div className="relative z-10 px-6 max-w-5xl mx-auto text-center">
            <h1 className="text-3xl md:text-5xl lg:text-6xl text-white font-medium tracking-wide leading-tight drop-shadow-lg">
              Accelerating the transition to <br className="hidden md:block" /> reliable, premium used cars.
            </h1>
          </div>
        </section>

        {/* 🚨 MISSION TEXT SECTION 🚨 */}
        <section className="py-20 md:py-32 px-6">
          <div className="max-w-4xl mx-auto text-center">
            <p className="text-[#393c41] text-lg md:text-2xl leading-relaxed font-light">
              <strong className="font-semibold text-[#002f34]">Bah! Car Plaza</strong> was founded to prove that buying a pre-owned vehicle doesn't have to be a compromise. We believe that used cars can be better, more reliable, and more accessible than buying new. Our mission is to build total trust and transparency in the used car ecosystem.
            </p>
          </div>
        </section>

        {/* 🚨 SPLIT CONTENT SECTION 1 🚨 */}
        <section className="py-12 px-6 max-w-[1400px] mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-20 items-center">
          <div className="w-full h-[400px] md:h-[500px] overflow-hidden rounded-lg">
            <img 
              src="https://images.unsplash.com/photo-1542282088-72c9c27ed0cd?auto=format&fit=crop&w=1000&q=80" 
              alt="Quality Check" 
              className="w-full h-full object-cover hover:scale-105 transition-transform duration-1000"
            />
          </div>
          <div className="max-w-lg">
            <h2 className="text-2xl md:text-3xl font-semibold text-[#171a20] mb-6">Engineered for Trust</h2>
            <p className="text-[#5c5e62] text-base md:text-lg leading-relaxed mb-6">
              Every car that enters our plaza undergoes a rigorous 140-point quality inspection. From the engine and transmission to the exterior paint and interior upholstery, we leave no stone unturned. If it doesn't pass our strict standards, it doesn't reach you.
            </p>
            <button onClick={() => setView('inspection-process')} className="text-[#ef5e33] font-semibold border-b-2 border-[#ef5e33] pb-1 hover:text-[#002f34] hover:border-[#002f34] transition-colors">
              Learn about our Inspection Process
            </button>
          </div>
        </section>

        {/* 🚨 SPLIT CONTENT SECTION 2 (Reversed) 🚨 */}
        <section className="py-20 md:py-32 px-6 max-w-[1400px] mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-20 items-center">
          <div className="max-w-lg order-2 md:order-1 ml-auto">
            <h2 className="text-2xl md:text-3xl font-semibold text-[#171a20] mb-6">Seamless Experience</h2>
            <p className="text-[#5c5e62] text-base md:text-lg leading-relaxed mb-6">
              We have eliminated the friction of traditional car buying. Whether you are looking to buy your dream car or sell your current one, our digital-first approach ensures a smooth, paperless, and hassle-free experience right from your home to our showroom.
            </p>
            <button onClick={() => setView('buy')} className="text-[#ef5e33] font-semibold border-b-2 border-[#ef5e33] pb-1 hover:text-[#002f34] hover:border-[#002f34] transition-colors">
              Explore our Inventory
            </button>
          </div>
          <div className="w-full h-[400px] md:h-[500px] overflow-hidden rounded-lg order-1 md:order-2">
            <img 
              src="https://images.unsplash.com/photo-1553440569-bcc63803a83d?auto=format&fit=crop&w=1000&q=80" 
              alt="Seamless Experience" 
              className="w-full h-full object-cover hover:scale-105 transition-transform duration-1000"
            />
          </div>
        </section>

        {/* 🚨 FULL WIDTH BANNER (Bottom - Image fixed!) 🚨 */}
        <section className="relative h-[60vh] w-full flex items-center justify-center mt-10">
          <img 
            src="https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?auto=format&fit=crop&w=2000&q=80" 
            alt="Join Bah Car Plaza" 
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/60"></div>
          
          <div className="relative z-10 text-center px-6">
            <h2 className="text-3xl md:text-5xl text-white font-medium tracking-wide mb-8 drop-shadow-md">
              The Future of Used Cars.
            </h2>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button onClick={() => setView('buy')} className="bg-transparent border-[3px] border-white text-white px-10 py-3 rounded font-bold uppercase tracking-wider hover:bg-white hover:text-[#002f34] transition-all duration-300">
                Buy a Car
              </button>
              <button onClick={() => { setView('account'); if(setActiveTab) setActiveTab('Sell Used Car'); }} className="bg-white border-[3px] border-white text-[#002f34] px-10 py-3 rounded font-bold uppercase tracking-wider hover:bg-gray-200 transition-all duration-300">
                Sell a Car
              </button>
            </div>
          </div>
        </section>

      </main>

      <Footer setView={setView} />
    </div>
  );
}

export default AboutUs;